<template>
<div>
    <div class="back-to-edit" id="save-and-continue-la"> <a class="pointer" @click="$router.go(-1)">
         <img class="mr-2" src="../../assets/images/u315.svg"/>Back to edit
        </a></div>

	<div class="layout-flex">
		<div class="first">
			<div class="modules-holder-wrapper">
                <div class="scroll-view-checkout">
				
						<div v-for="(module_, index) in current_program.modules" :key="index">
                            <div class="module-holder">
                                <div class="module-title-wrapper">
                                    {{module_.title}}
                                </div>
                                <div class="module-time-info-flex">
                                    <div class="module-time-info">
                                    {{ secondsToHms((module_.duration), true) }}
                                    </div>
                                    <span class="module-lesson-quiz-info">
                                        •
                                    </span>
                                    <div v-if="!module_.has_quiz" class="module-lesson-quiz-info">
                                        {{module_.lessons.length}} Lessons
                                    </div>
                                    <div v-else class="module-lesson-quiz-info">
                                        {{module_.lessons.length -1 }} Lessons + Final Quiz
                                    </div>
                                </div>
                            </div>
						</div>
					</div>
				
				<div class="program-info-holder">
					<div class="program-info">
						Total Duration : 
						<span class="duration-total"> {{totalDurationCalc}}</span>
					</div>
				</div>

			</div>
		</div>


		<div class=line-holder>
		 	<!-- <img class="line line-heigh-50" src="../../assets/images/u37-hr-line.svg"/> -->
			 <hr width="1" size="500">
		</div>


		<div class="second">
			<div class="blue-title your-program-size">
				Your Program
			</div>
			<div class="input-holder">
				  <shopify-program-name @updateProgram="updateProgram" :current_program="current_program"/>
			</div>
			<div class="blue-title">
				Agency
			</div>
			<div class="agency-selection">
				<v-select :searchable="true" track-by="name" multiple label="name" :options="agencies" v-model="agency" class="green bg-gray v-select-no-height" single @input="organizationChanged">
			</v-select>
			</div>
			<div class="blue-title">
				Notes
			</div>
			<div class="agency-selection">
				<textarea class="textarea-modal no-border" v-model="current_program.notes" placeholder="Notes"></textarea>
			</div>
             <shopify-checkout-button @goToCheckout="goToCheckout"
            @saveModuleGoDraftsPage="saveModuleGoDraftsPage"
            :show_save_button="false"
             :fullWidth="true">Checkout</shopify-checkout-button>
		</div>
	</div>
    </div>
</template>

<script>
import MixinSME from '../sme/MixinSME';
import ShopifyProgramName from './ShopifyProgramName'
import ShopifyCheckoutButton from './ShopifyCheckoutButton'
export default {
     components: {
        ShopifyProgramName,
        ShopifyCheckoutButton
          
    },
	mixins: [MixinSME],
	data: function(){
		return{
			id: this.$route.params.id,
			// module_list : this.$route.query.program[0],
			program_name: '', 
			current_program:'',
			agencies: [],
			agency:'',
			notes:''

		}
	},
	computed:{
		totalDurationCalc: function (){
			let total = 0
			this.current_program.modules.forEach(elem => total += elem.duration)
			return this.secondsToHms(total,true);
		},
        organization_ids: function(){
            if(this.agency.length != 0){
                let ids = []
                this.agency.map(a=> ids.push(a.id))
                return ids
                
            }else{
                return ''
            }
        }
    },
	created : function(){
		this.getProgram();
		this.getAgencies();
	},
	methods:{
		getAgencies: function(){
            var params = {
            filters : {
                per_page : 500
            }
           }
            this.$store.dispatch('getOrganizations', params).then((res) => {
                this.agencies = res.data.data
         
			}).catch((error) => {
				console.log(error);
			});
        },
		getProgram: function(){
			var params = {
				id : this.id,
				filters : {
					full : true,
					page_loading : false
				}
			}
            this.$store.dispatch('getDraft', params).then((res) => {
					this.current_program = res.data.data;
                    
            }).catch((error) => {
                console.log(error);
            })
        },
		organizationChanged: function(){

		},
        goToCheckout: function(){
            var params = this.current_program;
            delete params["image"]; 
            params.organization_ids = this.organization_ids
            this.$store.dispatch('createCourseShopify', params).then((res) => {
                this.$router.push({ name : 'shopify.dashboard', params:{ id: this.current_program.id} })
             
            }).catch((error) => {
               
            });

        },
        updateProgram: function(){
            this.$store.dispatch('editDraft', this.current_program).then((res) => {
                this.$nextTick(()=>{
			    	this.current_program = res.data.course
                    this.$forceUpdate();

                })
            }).catch((error) => {
                console.log(error);
            });
        },
        saveModuleGoDraftsPage: function(){
            this.$router.push({ name : 'shopify.dashboard', params:{ id: this.current_program.id} })
        },

	}
}
</script>
<style>
.scroll-view-checkout{
    overflow: scroll;
    height: 87%;
}
.back-to-edit{
    text-align: left !important;
    margin-bottom: 15px;
}
.create-new-program{
	cursor: pointer;
	border-width: 0px;
    width: 298px;
    height: 56px;
	background-color: #11a5a7;
	 border-radius: 4px;
  box-sizing: border-box;
 font-family: 'Gilroy', sans-serif;
  color: #333333;
  text-align: center;
  line-height: normal;
  color:white;
  font-size: 22px;

}
.button-inside{
	padding: 12px;
}
#save-and-continue-la {
  width: auto;
  height: 24px;
  background-color: rgba(255, 255, 255, 0);
  font-size: 1.0rem;
  box-sizing: border-box;
  font-family: 'Gilroy', sans-serif;
  text-decoration: underline;
  color: #11a5a7;
  text-align: center;
  line-height: normal;
}
.cont-button{
    border-radius: 10px;
    width: 100%;
    height: 45px;
    font-family: 'Gilroy', sans-serif;
    font-size: 22px;
    color: #ffffff;
    text-align: center;
    line-height: normal;
}
.layout-flex{
	display: flex;
	flex-direction: row;
}
.program-holder-wrapper{
  	margin-bottom: 30px;
}
.first{
	width: 60%;
}
.line-holder{
	width: 5%;
	margin-right: 30px;
}
.second{
	width: 25%;
    position: relative;
    top: -25px;
}
.modules-holder-wrapper {
	/* position: absolute;
	bottom: 100px;
	top: 40px; */
	position: relative;
	display: flex;
	flex-flow: column;
	/* width: 60%; */
  /* width: 830px; */
  height: 676px;
  max-height: 676px !important;
  border-radius: 8px;
  background-color: #f2f2f2;
  box-sizing: border-box;
  font-family: 'Arial Regular', 'Arial', sans-serif;
  color: #333333;
  text-align: center;
  line-height: normal;
  padding: 10px;
  margin-bottom: 30px;
}
.module-holder {
  margin-bottom: 8px;
  width: 100%;
  height: 75px;
  border: none;
  border-radius: 8px;
  background-color: #ffffff;
  box-sizing: border-box;
}
.program-info-holder{
	border-width: 0px;
	position: absolute;
    bottom: 0px;
	left: 0px;
    /* position: absolute;
    left: 49px;
    top: 687px; */
    width: 100%;
    height: 92px;
    display: flex;
    font-family: 'Gilroy', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 18px;
    text-align: left;
}
.program-info{
	padding: 33px 0px 29px 8px;
	border-width: 0px;
    /* position: absolute;
    left: 47px;
    top: -55px; */
    width: 100%;
    height: 92px;
    background: inherit;
    background-color: rgba(128, 128, 128, 0.1450980392156863);
    border: none;
    border-radius: 8px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: 'Gilroy', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 18px;
    text-align: left;
}
.module-title-wrapper{
	padding-top: 10px;
	padding-left: 16px;
	text-align: left;
	border-width: 0px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 95%;
    height: 45px;
    background: inherit;
    background-color: rgba(255, 255, 255, 0);
    border: none;
    border-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: 'Gilroy Bold', 'Gilroy Regular', 'Gilroy', sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 22px;
}
.module-time-info{
	font-family: 'Gilroy Bold', 'Gilroy Regular', 'Gilroy', sans-serif;
    font-weight: 700;
    color: #11A5A7;
	font-size: 18px;
	padding-left: 16px;
	margin-top: 16px;
	text-align:left;
	width: auto;
}
.module-time-info-flex{
	display: flex;
	flex-direction: row;
    margin-top: -20px;
}
.module-lesson-quiz-info{
	font-family: 'Gilroy', sans-serif;
    font-weight: 400;
    font-size: 16px;
    color: #7F7F7F;
	width: auto;
	text-align: left;
    margin-top: 18px;
	margin-left: 5px
}
.duration-total{
	font-family: 'Gilroy Bold', 'Gilroy Regular', 'Gilroy', sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 22px;
}
.line{
     border-width: 0px;
    position: relative;
    left: 10;
    top: 10px;
    width: 896px;
    height: 1px;
    display: flex;
    -webkit-transform: rotate(
270deg
);
    -moz-transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    transform: rotate(
270deg
);
}
.no-border{
    /* border: none;  */
	border-top: none;
    border-left: none;
    border-right: none;
	width: 100%;
	border-width: 1px;
	/* text-align: left;
    text-transform: none;
    background-color: transparent;
    border-color: transparent; */
}
.blue-title{
	font-family: 'Gilroy', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    color: #11A5A7;
	margin-bottom: 12px;
	margin-top: 18px;
}
.your-program-size{
    font-size: 18px !important;
}
.input-holder{
	font-family: 'Gilroy Bold', 'Gilroy', sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 22px;
    letter-spacing: normal;
    color: #333333;
}
.agency-selection{
	font-family: 'Gilroy', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    letter-spacing: normal;
    color: #555555;
    vertical-align: none;
    text-align: left;
    text-transform: none;
    background-color: transparent;
    border-color: transparent;
}
.notes-modal{
	border-width: 0px;
	width: 372px;
	height: 109px;
	display: flex;
	font-family: 'Gilroy', sans-serif;
	font-weight: 400;
	font-style: normal;
	font-size: 16px;
    padding: 4px 8px 4px 8px;
	margin-bottom:32px;
}
.textarea-modal{
	min-height: 150px;
    width: 100%;
    
}

@media only screen and (max-width: 600px) {
  .modules-holder-wrapper{
	  width: 95%;
  }
}
@media only screen and (max-width: 600px) {
  .first, .second{
	  width: 95%;
  }
  .layout-flex{
      flex-direction: column;
  }
}
@media only screen and (max-width: 750px) {
  .modules-holder-wrapper{
	  width: 100%;
	  max-width: 500px;
	  overflow: hidden;
	  text-overflow: ellipsis;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shopify/ShopifyCheckout.vue